export default "__VITE_ASSET__CxS$BxD0__"